import { NAME_REGEX } from '@/consts/validation';
import { type AnalyticsPatientResource } from '@/types/metrics/analyticsPatient';

export const getBirthdate = (patient?: AnalyticsPatientResource) => {
  if (!patient?.date_of_birth) {
    return '';
  }

  const dobParts = patient?.date_of_birth.split('-');

  return `${dobParts[1]}/${dobParts[2]}/${dobParts[0]}`;
};

export const getPrescriptionBottleName = (
  legalFirstName: string,
  legalLastName: string,
) => {
  if (
    isLegalFirstNameValid(legalFirstName) &&
    isLegalLastNameValid(legalLastName)
  ) {
    return `${legalFirstName.trim()} ${legalLastName.trim()}`;
  } else if (isLegalFirstNameValid(legalFirstName)) {
    return legalFirstName.trim();
  } else if (isLegalLastNameValid(legalLastName)) {
    return legalLastName.trim();
  }

  return '(Your Name Here)';
};

export const isBirthdateValid = (birthdate?: string) => {
  if (!birthdate) {
    return false;
  }

  if (birthdate.trim().length !== 10) {
    return false;
  }

  const birthdateParts = birthdate.split('/');

  const birthdateDate = new Date(
    `${birthdateParts[2]}-${birthdateParts[0]}-${birthdateParts[1]}`,
  );

  const today = new Date();

  return (
    birthdateDate <= today &&
    today.getFullYear() - birthdateDate.getFullYear() <= 100
  );
};

export const isLegalFirstNameValid = (legalFirstName: string) => {
  return NAME_REGEX.test(legalFirstName.trim());
};

export const isLegalLastNameValid = (legalLastName: string) => {
  return NAME_REGEX.test(legalLastName.trim());
};

const isUnderAge = (
  age: number,
  dob: string,
  dateSeparatedBySlashes: boolean,
) => {
  let dobDate;

  if (dateSeparatedBySlashes) {
    const dobParts = dob.split('/');

    const formattedDob = new Date(
      `${dobParts[2]}-${dobParts[0]}-${dobParts[1]}`,
    );

    dobDate = new Date(formattedDob);
  } else {
    dobDate = new Date(dob);
  }

  const todayDate = new Date();

  const cutOffDate = new Date();
  cutOffDate.setFullYear(todayDate.getFullYear() - age);

  return dobDate >= cutOffDate;
};

export const isUnder13 = (
  dob: string,
  dateSeparatedBySlashes: boolean = true,
) => {
  return isUnderAge(13, dob, dateSeparatedBySlashes);
};

export const isUnder18 = (
  dob: string,
  dateSeparatedBySlashes: boolean = true,
) => {
  return isUnderAge(18, dob, dateSeparatedBySlashes);
};
